// src/services/searchService.js
import { api } from './apiService';

export async function searchProfiles(query, page = 1, filters = []) {
  try {
    const params = new URLSearchParams({
      searchterm: query,
      page: page.toString()
    });
    
    // Add filters to the query parameters
    if (filters && filters.length > 0) {
      filters.forEach(filter => {
        params.append('filters', filter);
      });
    }
    
    const response = await api.get(`/search/profiles?${params.toString()}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function refreshProfile(encodedLink) {
  try {
    const response = await api.get(`/profile/update/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
} 

export async function getSearchQueries(page = 1, pageSize = 10) {
  try {
    const response = await api.get(`/search/user-searches?page=${page}&pageSize=${pageSize}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function getSearchStats() {
  try {
    const response = await api.get('/search/stats');
    return response.data;
  } catch (err) {
    throw err;
  }
}

// get profile details data
export async function getProfile(encodedLink) {
  try {
    // const response = await api.get(`/profile/id/${encodedLink}`);
    const response = await api.get(`/profile/details/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
} 
export async function profileBasics(encodedLink) {
  try {
    const response = await api.get(`/profile/basic/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
// export async function profileBasics(encodedLink) {
//   try {
//     const response = await api.get(`/profile/basic/${encodedLink}`);
//     return response.data;
//   } catch (err) {
//     throw err;
//   }
// }
export async function profileWork(encodedLink) {
  try {
    const response = await api.get(`/profile/work/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function profileEducation(encodedLink) {
  try {
    const response = await api.get(`/profile/education/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function profileSkills(encodedLink) {
  try {
    const response = await api.get(`/profile/skills/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function profileSwot(encodedLink) {
  try {
    const response = await api.get(`/profile/swot/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function profileRecommendations(encodedLink) {
  try {
    const response = await api.get(`/profile/recommendation/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}
export async function profileMetrics(encodedLink) { 
  try {
    const response = await api.get(`/profile/metrics/${encodedLink}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}